module.exports = __webpack_public_path__ + "assets/248e02b265771fb6c94227568e7ce8d5.js";